import { Component, OnInit } from '@angular/core';
import { PageAction } from '../../../components/page-actions/page-actions.component';
import { GroupService } from '@services/groups/group.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Models } from '@ibexfusion/models';

@Component({
    selector: 'app-group-detail',
    templateUrl: './group-detail.component.html',
    styleUrls: ['./group-detail.component.scss'],
    providers: [GroupService],
    standalone: false
})
export class GroupDetailComponent implements OnInit {

  public title = 'Group';

  pageActions: PageAction[] = [];
  boundGroup: Models.Group;

  objectKeys = Object.keys;

  constructor(private groupService: GroupService, private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    this.groupService.get(this.route.snapshot.params['id']).then(result => {
      if (!result) {
        console.error('no group found');
        throw new Error('no group found');
      }
      this.boundGroup = new Models.Group();
      this.boundGroup.populateFromJSON(result);
      this.title = 'Detail Group: ' + this.boundGroup.name;
      this.createPageActions();
      console.log(this.boundGroup);
    });
  }

  createPageActions() {
    this.pageActions = [
      new PageAction({
        icon: 'edit',
        title: 'Edit Group',
        callback: () => {
          this.router.navigate(['groups', this.route.snapshot.params['id'], 'edit']);
        }
      }),
      new PageAction({
        icon: 'assignment_ind',
        title: 'Manage Roles',
        callback: () => {
          this.router.navigate(['groups', this.route.snapshot.params['id'], 'roles']);
        }
      }),
      new PageAction({
        icon: 'person',
        title: 'Manage Participants',
        callback: () => {
          this.router.navigate(['groups', this.route.snapshot.params['id'], 'participants']);
        }
      }),
      new PageAction({
        icon: 'bookmark_add',
        title: 'Group has Content only',
        callback: () => {
          this.router.navigate(['groups', this.route.snapshot.params['id'], 'has-content']);
        }
      }),
      new PageAction({
        icon: 'lock',
        title: 'Group has secured app',
        callback: () => {
          this.router.navigate(['groups', this.route.snapshot.params['id'], 'has-secured-app']);
        }
      })
    ]
  }
}
